import React, { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import MainContainer from './containers/main-container/MainContainer';
import LoginContainer from './containers/login-container/LoginContainer';
import { PrivateRoute } from './components';
import 'antd/dist/antd.css';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/login" element={<LoginContainer />}></Route>
          <Route
            path="*"
            element={
              <PrivateRoute requireUser={false}>
                <MainContainer />
              </PrivateRoute>
            }
          ></Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
